import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/scss/components/industrial/full-width-cta.module.scss';
import { supSub } from '../../services/util';

const FullWidthCTA = ({ title, buttons }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: supSub(title) }} />
        <div className={styles.buttonContainer}>
          {buttons.map((button, index) => (
            <a 
              key={index} 
              href={button.url} 
              className={button.isSecondary ? styles.buttonSecondary : styles.button}
            >
              <span dangerouslySetInnerHTML={{ __html: supSub(button.text) }} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

FullWidthCTA.propTypes = {
  title: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      isSecondary: PropTypes.bool
    })
  ).isRequired
};

export default FullWidthCTA;
